import { render } from "./LocationEdit.vue?vue&type=template&id=24162dd8&scoped=true"
import script from "./LocationEdit.vue?vue&type=script&lang=js"
export * from "./LocationEdit.vue?vue&type=script&lang=js"

import "./LocationEdit.vue?vue&type=style&index=0&id=24162dd8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24162dd8"]])

export default __exports__